<mat-checkbox  [ngClass]="labelClass" *ngIf="checkbox">
  {{label}}
</mat-checkbox>
<label *ngIf="!checkbox" [ngClass]="labelClass">{{ label }}</label>
<mat-form-field>
  <input  appRestrict restrict="[0-9]"  matInput [(ngModel)]="hours" (change)="calculateResult()" id="{{label}}_hours" placeholder="HH"  [disabled]="disabled" maxlength="2">
</mat-form-field>
<span class="colon">:</span>
<mat-form-field>
  <input matInput appRestrict restrict="[0-9]" [(ngModel)]="minutes" (change)="calculateResult()" id="{{label}}_minutes" placeholder="MM" maxlength="2" [disabled]="disabled">
</mat-form-field>
